import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { IndustriesModule } from './industries/industries.module';
import { ProductsModule } from './products/products.module';
import { ContactusModule } from './contact_us/contactus.module';


import {AppRoutingModule} from './app-routing.module';

import { AppComponent } from './app.component';
import { CommonModule } from './common/common.module';
import { AboutusModule } from './about_us/aboutus.module';
// import { CommonComponent } from './common.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    CommonModule,
    AppRoutingModule,
    AboutusModule,
    IndustriesModule,
    ProductsModule,
    ContactusModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts